import { render, staticRenderFns } from "./gd-dlysjg-hazard-events.vue?vue&type=template&id=36e04872&scoped=true"
import script from "./gd-dlysjg-hazard-events.vue?vue&type=script&lang=js"
export * from "./gd-dlysjg-hazard-events.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e04872",
  null
  
)

export default component.exports